// import 'zone.js';  // Removed - testing if OnPush everywhere is sufficient

(window as any).global = window;
